import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton} from '../../../../../libs/shared/ui/src/components/utility/skeleton';
import {boxShadow} from '../../../../../libs/shared/ui/src/theme/themeStyleHelpers';

/*
 * Props.
 */

interface ApplicationCardSkeletonProps {
  hasButton?: boolean;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;
  padding: 20px;
  border: 1px solid ${(p) => p.theme.alphas.black20};
  ${(p) => boxShadow(p.theme, `0px 1px 9px ${p.theme.alphas.black20}`)};
  border-radius: 16px;
`;

const StyledApplicationCardHeaderDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
  overflow: hidden;
  align-items: center;
`;

const StyledHeaderAvatarDiv = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  box-sizing: border-box;
`;

const StyledHeaderNameDiv = styled.div`
  flex: 1;
  align-items: center;
  display: flex;
`;

const StyledDescriptionWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
  margin-bottom: 8px;
`;

/*
 * Component.
 */

export const ApplicationCardSkeleton: FC<ApplicationCardSkeletonProps> = (props) => {
  const {hasButton} = props;
  return (
    <StyledWrapperDiv>
      <StyledApplicationCardHeaderDiv>
        <StyledHeaderAvatarDiv>
          <Skeleton width="30px" height="30px" />
        </StyledHeaderAvatarDiv>
        <StyledHeaderNameDiv>
          <Skeleton height="16px" />
        </StyledHeaderNameDiv>
      </StyledApplicationCardHeaderDiv>
      <StyledDescriptionWrapperDiv>
        <Skeleton height="16px" />
        <Skeleton height="16px" />
      </StyledDescriptionWrapperDiv>
      {hasButton && <Skeleton width="130px" height="30px" borderRadius="100px" />}
    </StyledWrapperDiv>
  );
};
